/* eslint-disable */
// @ts-nocheck
import React, { PureComponent } from 'react';
import * as R from 'ramda';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { toSelectFormatEventDatasourceMap, getDataSourcesFromEvent, toSelectFormatCohortEventDatasourceMap } from './utils';
import Dropdown from '../../core/Dropdown';
import type { AccessControlReducer } from '../../../../main/types/accessControlTypes';
import { hasAccessToRevenueData } from '../../../../main/services/RevenueRestrictionsService';
import { dedupe } from '../../../../common/support/utils';
import { REVENUE_RELATED_EVENT_NAMES } from '../../../../common/support/eo_mapping/event_names';
import { EO_INSTALL, REVENUE, REVENUE_IN_LOCAL_CURRENCY } from '../../../support/eo_mapping/datasources';
import { SUMMARY_PAGE_STYLE_VARIANT } from '../../../../main/screens/ScreenNewSummary/newSummaryConstants';
type Props = {
  events: Array<string>;
  eventList: Array<string>;
  updateEvent?: (event: Array<string>) => void;
  updateQuery?: (arg0: Record<string, any>) => void;
  queryParam: string;
  maxEvents: number;
  minEvents: number;
  accessControl?: AccessControlReducer;
  hideCompareBy?: boolean;
  styleVariant?: string;
  closeMenuOnSelect?: boolean;
  disableQueryUpdate?: boolean;
  eventLabelsOverride?: boolean;
};
type OnChangeEvent = {
  value: string;
};

class MultiEventSelect extends PureComponent<Props> {
  updateEvent = (key: string) => {
    return (e: Array<OnChangeEvent>): void => {
      if (!e) {
        return;
      }

      let events = e.map((o) => o.value);
      const { minEvents, maxEvents } = this.props;

      if (events.length < minEvents) {
        return;
      }

      if (events.length > maxEvents) {
        events = [...events.slice(0, maxEvents - 1), events[events.length - 1]];
      }

      const { accessControl, updateEvent, updateQuery } = this.props;

      if (key === 'data_sources') {
        events = this._shouldUpdateEventAndQueryForRevenueAccess(accessControl, events, key)
          ? this._updateEventsForRevenueAccess(events)
          : events;

        this._updateEventAndQuery(events, key, updateEvent, updateQuery);

        return;
      }

      if (key === 'cohort_event_types') {
        updateEvent && updateEvent(events);
        return;
      }
    };
  };

  _hasRevenueDataAccess = (accessControl) => {
    return hasAccessToRevenueData(accessControl);
  };

  _shouldUpdateEventAndQueryForRevenueAccess = (accessControl, events, queryParam) => {
    const eventsIncludeRevenue = events && (events.includes(REVENUE) || events.includes(REVENUE_IN_LOCAL_CURRENCY));
    return !this._hasRevenueDataAccess(accessControl) && eventsIncludeRevenue && queryParam === 'data_sources';
  };

  _updateEventAndQuery = (events, key, updateEvent, updateQuery) => {
    if (!events || !events.length || !key || !updateEvent || !updateQuery) {
      return;
    }

    const { disableQueryUpdate } = this.props;
    updateEvent(events);
    const dataSources = dedupe(events.map(getDataSourcesFromEvent));

    if (disableQueryUpdate) {
      return;
    }

    updateQuery({
      [key]: dataSources,
    });
  };

  _updateEventAndQueryForRevenueAccess = (props) => {
    const { accessControl, events, updateEvent, updateQuery, queryParam } = props;

    if (this._shouldUpdateEventAndQueryForRevenueAccess(accessControl, events, queryParam)) {
      this._updateEventAndQuery(this._updateEventsForRevenueAccess(events), queryParam, updateEvent, updateQuery);
    }
  };

  _updateEventsForRevenueAccess = (events = []) => {
    const noRevenueEvents = events.filter((event) => event !== REVENUE && event !== REVENUE_IN_LOCAL_CURRENCY);

    if (!noRevenueEvents.includes(EO_INSTALL)) {
      noRevenueEvents.push(EO_INSTALL);
    }

    return noRevenueEvents;
  };

  componentWillMount() {
    this._updateEventAndQueryForRevenueAccess(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.events != this.props.events) {
      this._updateEventAndQueryForRevenueAccess(nextProps);
    }
  }

  render() {
    const {
      events,
      eventList = [],
      queryParam,
      accessControl,
      hideCompareBy,
      styleVariant,
      closeMenuOnSelect,
      eventLabelsOverride = {},
    } = this.props;

    const revenueDataAccess = this._hasRevenueDataAccess(accessControl);

    const eventAccessList = eventList.filter((filter) => {
      return !(REVENUE_RELATED_EVENT_NAMES.includes(filter) && !revenueDataAccess);
    });
    const eventOptions =
      queryParam === 'cohort_event_types'
        ? toSelectFormatCohortEventDatasourceMap(eventAccessList)
        : toSelectFormatEventDatasourceMap(eventAccessList, eventLabelsOverride);

    if (!eventOptions.length) {
      return null;
    }

    return (
      <div className="h_d-f">
        <span
          className={classNames('analytics-filters__starter', {
            'no-compare-by': hideCompareBy,
          })}
        >
          Show
        </span>
        <Dropdown
          testid="show-select"
          i13nLabel="Show Event"
          clearable={false}
          options={eventOptions}
          value={events}
          multi={true}
          onChange={this.updateEvent(this.props.queryParam)}
          className={classNames('source-row__select', {
            'in-modal': styleVariant === SUMMARY_PAGE_STYLE_VARIANT,
          })}
          closeMenuOnSelect={closeMenuOnSelect}
        />
      </div>
    );
  }
}

export default connect(R.pick(['accessControl']), null)(MultiEventSelect);
